import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/site/Hero";
import { Marquee, PromoBanner } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { WhyChoose } from "@/components/site/WhyChoose";
import { Stats } from "@/components/site/Stats";
import { Portfolio } from "@/components/site/Portfolio";
import { Pricing } from "@/components/site/Pricing";
import { Process } from "@/components/site/Process";
import { Testimonials } from "@/components/site/Testimonials";
import { Faq } from "@/components/site/Faq";
import { Contact } from "@/components/site/Contact";
import { FinalCta } from "@/components/site/FinalCta";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    document.title = "Website Designing Company in Noida | Pratap Group";
    if (!hash) return undefined;
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 350);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <PromoBanner />
      <Marquee />
      <About />
      <Stats />
      <Services />
      <WhyChoose />
      <Portfolio />
      <Pricing />
      <Process />
      <Testimonials />
      <Faq />
      <Contact />
      <FinalCta />
    </main>
  );
}
